var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-lined-card',{staticClass:"blog-slide-card",attrs:{"to":_vm.to,"image":_vm.thumbnail,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }